import ReactModal from "react-modal";
import { useGlobalContext } from "../../context";
import CloseIcon from "@mui/icons-material/Close";
import React, {useEffect, useState} from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import "./MonthlyPosts.css"
import {sendPostFiles, sendSchedulePost} from "../../api";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function PostsPopup({ checkinClient, setShowUsers }) {

    const {
        openMonthlyPosts,
        setOpenMonthlyPotst
    } = useGlobalContext()

    const [postsDays, setPostsDays] = useState([]);
    const [files, setFiles] = useState([]);
    const [postsData, setPostsData] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [dateTime, setDateTime] = useState();
    const [showDateInput, setShowDateInput] = useState(false);
    const [pending, setPending] = useState(false);
    const [errorImageLoading, setErrorImageLoading] = useState(false);

    const getPostingDaysInMonth = (month, year, day) => (new Array(31))
        .fill('')
        .map((v, i) => new Date(year, month, i + 1, 9, 0, 0))
        .filter(v => v.getMonth() === month && v.getDate() >= day  && v.getDay() === 1 || v.getMonth() === month && v.getDate() >= day && v.getDay() === 3 || v.getMonth() === month && v.getDate() >= day  && v.getDay() === 5)
        .map(item => {
            return {
                date: item
            }
        })

    useEffect(() => {
        const date = new Date();
        const month = date.getMonth();
        const year = date.getFullYear();
        const day = date.getDate();
        setPostsDays(getPostingDaysInMonth(month, year, day));
    }, []);

    const filesHandler = e => {
        if (e.target.files.length === 1) {
            if (e.target.files[0].size < 4 * 1048576) {
                setFiles(files => {
                    return  [e.target.files[0]];
                });
            }
        }
        else {
            for (let i = 0; i < e.target.files.length; i++) {
                if (e.target.files[i].size < 4 * 1048576) {
                    setFiles(files => { return [...files, e.target.files[i]] });
                }
            }
        }
    }

    const filesInFormData = async (fileData) => {
        setPending(true);
        let formData = new FormData();
        fileData.forEach( (item, index) => {
            formData.append(`images[${index}]`, item);
        })
        try {
            const response = await sendPostFiles(formData);
            if (response.data) {
                const postsResponseData = response.data.map((item, index) => {
                    return {
                        id: index + 1,
                        attachments: item,
                        caption: "",
                        scheduleDate: postsDays[index]?.date,
                        category: null,
                        postingType: "SINGLE_IMAGE",
                        scheduleType: "CLIENT"
                    }
                });
                setPostsData(postsResponseData);
                setFiles([]);
            }
        }
        catch(err) {
            setErrorImageLoading(true);
            console.log(err);
        }
        finally {
            setPending(false);
        }
    }

    useEffect(() => {
        if (files.length > 0) {
            filesInFormData(files);
        }
    }, [files]);

    const changeCaption = (number, value) => {
        setPostsData(postsData => postsData.map((item, index) => {
            if (index === number) {
                return {
                    ...item,
                    caption: value,
                }
            }
            else {
                return {
                    ...item
                }
            }
        }))
    }

    const addDateTime = () => {
        if (dateTime) {
            setPostsData(postingData => postingData.map((item) => item.id === postsData[pageNumber].id ? { ...item, scheduleDate: dateTime?.$d } : { ...item }));
        }
        setShowDateInput(false);
    }

    const submitMonthlyPosts = () => {
        try {
            if (postsData.length > 0) {
                postsData.forEach(async (item) => {
                    let form = {
                        caption: item.caption,
                        attachments: [item.attachments],
                        clients: [checkinClient],
                        scheduleDate: item.scheduleDate.toString(),
                        scheduleType: item.scheduleType,
                        category: item.category,
                        postingType: item.postingType,
                    };
                    await sendSchedulePost(JSON.stringify(form));
                })
                setPostsData([]);
                setShowUsers(showUsers => showUsers.map(user => { return { ...user, active: false } }));
                setOpenMonthlyPotst(false)
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    return (
        <ReactModal
            isOpen={openMonthlyPosts}
            onRequestClose={() => setOpenMonthlyPotst(false)}
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 300,
                },
                content: {
                    width: "90%",
                    top: "5px",
                    maxWidth: '580px',
                    maxHeight: "730px",
                    height: "85vh",
                    border: 'none',
                    margin: "auto",
                    left: "5%",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    overflowY: "auto",
                }
            }}
        >
            <div
                style={{
                    width: "100%",
                    height: "auto",
                    display: window.innerWidth >= 620 ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
            >
                <CloseIcon
                    style={{
                        cursor: "pointer",
                        color: "rgba(0,0,0,0.5)",
                        fontSize: "20px"
                    }}
                    onClick={() => setOpenMonthlyPotst(false)}
                />
            </div>
            {
                postsData.length === 0 ?
                    <span className="addPostAddFileSpan monthlyPostFileSpan">
                        <AttachFileIcon
                            style={{
                                transform: "rotate(45deg)",
                                color: "#666666",
                                margin: "0 10px"
                            }}
                        />
                        <input
                            type="file"
                            className="addFileInput"
                            onChange={filesHandler}
                            multiple={true}
                            accept=".jpg, .jpeg, .png, .mp4, .avi"
                        />
                        Choose Files
                    </span>
                    :
                    null
            }
            {
                pending ? <span style = {{color: "blue", margin: "10px auto"}}>Please Wait ... </span> : null
            }
            {
                errorImageLoading ? <span style = {{color: "red", margin: "10px auto"}}>Server Error</span> : null
            }
            {
                postsData.length > 0 ?
                    <>
                        <div className="monthlyPostExampleBox">
                            <img src={postsData[pageNumber]?.attachments} className="monthlyPostExampleImage" alt=""/>
                            <textarea
                                className="monthlyPostExampleCaption"
                                placeholder="Caption"
                                value={postsData[pageNumber]?.caption}
                                onChange={e => changeCaption(pageNumber, e.target.value)}
                            />
                            {
                                !showDateInput && postsData[pageNumber]?.scheduleDate ?
                                    <span className="monthlyPostExampleDateTimeText">
                                        <span>Date & Time :</span>
                                        { postsData[pageNumber]?.scheduleDate.toLocaleString() }
                                        <AccessTimeIcon
                                            style={{
                                                color: "#999999",
                                                fontSize: "28px",
                                                cursor: "pointer",
                                                margin: "0 0 0 10px"
                                            }}
                                            onClick={() => setShowDateInput(true)}
                                        />
                                    </span>
                                    :
                                    <span className="monthlyPostExampleDateTimeText">
                                        <span>Date & Time :</span>
                                         <DateTimePicker
                                             className="postScheduleDateTimePicker"
                                             value={dateTime}
                                             ampm={true}
                                             onChange={setDateTime}
                                             autoFocus={true}
                                             open={true}
                                             onClose={() => {
                                                 addDateTime()
                                             }}
                                         />
                                    </span>
                            }
                        </div>
                        <div className="monthlyPostExampleBtnsBox">
                            <button
                                className="monthlyPostExampleBtn"
                                onClick={() => {
                                    setPageNumber(page => {
                                        if (page > 0) {
                                            return --page;
                                        }
                                        else {
                                            return page = 0;
                                        }
                                    });
                                    setDateTime();
                                }}
                            >
                                Prev
                            </button>
                            <button
                                className="monthlyPostExampleBtn"
                                onClick={() => {
                                    setPageNumber(page => {
                                        if (page < postsData.length - 1) {
                                            return ++page;
                                        } else {
                                            return page = postsData.length - 1;
                                        }
                                    });
                                    setDateTime();
                                }}
                            >
                                Next
                            </button>
                        </div>
                        {
                            pageNumber === postsData.length - 1 &&
                            <span className="monthlyPostExampleSubmitBtnBox">
                                <button
                                    className="monthlyPostExampleSubmitBtn"
                                    onClick={submitMonthlyPosts}
                                >
                                    Submit
                                </button>
                            </span>
                        }
                    </>
                    :
                    null
            }
        </ReactModal>
    )
}

export default PostsPopup